import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'amountPlaceholder',
  standalone: false,
})
export class AmountPlaceholderPipe implements PipeTransform {
  transform(type: 'percent' | 'flat', symbol: string): string {
    if (type === 'percent') {
      return $localize`Amount (%):`
    } else {
      return $localize`Amount` + ` (${symbol}):`
    }
  }
}
